__turbopack_context__.v({
  "serviceIcon": "Services-module__3XLFUq__serviceIcon",
  "serviceItem": "Services-module__3XLFUq__serviceItem",
  "serviceTitle": "Services-module__3XLFUq__serviceTitle",
  "services": "Services-module__3XLFUq__services",
  "servicesCol": "Services-module__3XLFUq__servicesCol",
  "servicesRow": "Services-module__3XLFUq__servicesRow",
});
